import { createContext, useContext, useState } from 'react';
import { ContextProviderProps, FormData } from './interfaces';

interface CurrentDataContextType {
    currentData: FormData | undefined,
    setCurrentData: (val: FormData | undefined) => void;
};

export const CurrentDataContext = createContext({} as CurrentDataContextType);
export const useCurrentDataContext = () => useContext(CurrentDataContext);

export const CurrentDataContextProvider = ({ children }: ContextProviderProps) => {
    const [currentData, setCurrentData] = useState<FormData>();
    return <CurrentDataContext.Provider value={{ currentData, setCurrentData }}>
        {children}
    </CurrentDataContext.Provider>
};

